/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Stock_Check_ReadyInputs */

const vi_await_stock_check_ready = /** @type {(inputs: Await_Stock_Check_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho đã đủ. Bấm "Xác nhận đơn" để chốt.`)
};

/**

* @param {Await_Stock_Check_ReadyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_stock_check_ready = /** @type {((inputs?: Await_Stock_Check_ReadyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Stock_Check_ReadyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_stock_check_ready(inputs)
});